import React from 'react';
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import StatCard from '../StatCard'

const CardInfosValues = (props) => {
  const { text, icon, indicator, ...rest } = props

  const valor = useSelector((state) => state.dashboard?.dashboard?.[indicator]);

  return (
    <StatCard
      {...rest}
      label={text}
      value={'R$ ' + (valor ? valor.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '0,00')}
      icon={icon}
    />
  );
}

CardInfosValues.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  indicator: PropTypes.string.isRequired
}

export default CardInfosValues
